import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './chatSlice';
import websocketMiddleware from './websocketMiddleware';

const store = configureStore({
  reducer: {
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(websocketMiddleware),
});

export default store;
